import { createSelector } from "@ngrx/store";
import { AppState } from "src/app/store";

export namespace AuthSelectors {
  export const currentUser = (state: AppState) => state.auth.currentUser;
}